
































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import value from '*.json'
import staIdsData from '@/utils/staIdsData.json';

export default Vue.extend({
    props: ['barId', 'mapData'],
    watch: {
        barId() {
            // console.log(this.mapData)
        },
    },
    data() {
        return {
            up: false,
            down: false,
            dataList: [] as any,
        }
    },
    created() {
        this.dataList = this.mapData
        this.dataList.map((e: any) => {
          staIdsData.map((i: any) => {
            if (e.station_id_c === i.station_id_c) {
              e.station_name = i.station_name
              e.lon = i.lon
              e.lat = i.lat
            }
          })
        })

        console.log(this.dataList)
    },
    methods: {
        sortUp() {
            const arrNew = JSON.parse(JSON.stringify(this.mapData))
            let up = null
            if (this.up === false) {
                up = true
            } else {
                up = false
            }
            this.up = up
            if (this.up === true) {
                this.down = false
                const arrData = this.getChartSort(arrNew, 'value')
                this.dataList = arrData
            }
            if (this.up === false) {
                this.dataList = this.mapData
            }
            // console.log(this.dataList)
        },
        sortDown() {
            const arrNew = JSON.parse(JSON.stringify(this.mapData))
            let down = null
            if (this.down === false) {
                down = true
            } else {
                down = false
            }
            this.down = down
            if (this.down === true) {
                this.up = false
                const arrData = this.getChartSort(arrNew, 'value').reverse()
                this.dataList = arrData
            }
            if (this.down === false) {
                this.dataList = this.mapData
            }
        },
        showTable() {
            this.$emit('showTable', false)
        },
        getChartSort(json: any, key: any) {
            for (let j = 1, jl = json.length; j < jl; j++) {
                const temp = json[j]
                const val = temp[key]
                let i = j - 1;
                while (i >= 0 && json[i][key] > val) {
                    json[i + 1] = json[i];
                    i = i - 1;
                }
                json[i + 1] = temp;
            }
            return json;
        },
    },
})
